import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { style: {"font-size":".95rem","margin-left":"8px","margin-bottom":"-3px"} }
const _hoisted_5 = { class: "page-body" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "charts-content" }
const _hoisted_8 = { class: "d-flex full" }
const _hoisted_9 = { class: "data-content" }
const _hoisted_10 = { class: "count-detail" }
const _hoisted_11 = { class: "map-content" }
const _hoisted_12 = {
  class: "flex-1",
  style: {"position":"relative"}
}
const _hoisted_13 = {
  class: "d-flex",
  style: {"padding-bottom":"5vh"}
}
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = { class: "iframe" }
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!
  const _component_active_detail = _resolveComponent("active-detail")!
  const _component_table_div = _resolveComponent("table-div")!
  const _component_china = _resolveComponent("china")!
  const _component_quality = _resolveComponent("quality")!
  const _component_long = _resolveComponent("long")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createTextVNode(" MPE智慧健康数字化睡眠管理系统 ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString($setup.day) + " ", 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.time), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_my_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_my_card_body, { class: "pa-4" }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("div", null, [
                          _createElementVNode("p", { class: "title" }, "APP用户总数"),
                          _createElementVNode("p", { class: "value" }, "205682")
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_active_detail),
              _createVNode(_component_table_div, {
                style: {"height":"20%"},
                title: "设备列表",
                thead: ['设备号', '用户名'],
                list: $setup.deviceList
              }, null, 8, ["list"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_china)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_quality)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_long)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[2] || (_cache[2] = _createElementVNode("iframe", {
          src: `/#/gravity/realtime`,
          style: {"height":"33%"}
        }, null, -1)),
        _createElementVNode("iframe", {
          src: `/#/realtime?${$setup.query}`,
          style: {"height":"67%"}
        }, null, 8, _hoisted_17)
      ])
    ])
  ]))
}